import { createFileRoute, Outlet } from '@tanstack/react-router';

import { DashboardLayoutV2 } from 'src/components/layout/dashboard-layout/dashboard-layout-v2';

export const Route = createFileRoute('/_authed/dashboard')({
  component: DashboardLayout,
});

function DashboardLayout() {
  return (
    <DashboardLayoutV2>
      <Outlet />
    </DashboardLayoutV2>
  );
}
